import { FC } from 'react';
import styles from './MainTitle.module.scss';
import { Box } from '@mantine/core';

interface MainTitleProps {
  count?: number;
  selectedCount?: number;
  title?: string;
}

export const MainTitle: FC<MainTitleProps> = ({
  count = 0,
  title,
  selectedCount = 0,
}) => {
  const role = localStorage.getItem('role');
  return (
    <Box
      className={styles.root}
      m={{
        base: '8px 0 12px 0',
        sm: role === 'director' ? '20px 0 20px 0' : '40px 0 20px 0',
      }}>
      {title && (
        <p className={styles.title}>
          {title}
          {count > 0 && <sup className={styles.title_count}>{count}</sup>}
          {selectedCount > 0 && (
            <sup className={styles.title_selected}>({selectedCount})</sup>
          )}
        </p>
      )}
    </Box>
  );
};
